import { Auth } from "aws-amplify";
import { AppModule } from "src/app/app.module";
import { Member } from "src/app/backend/models/member/member";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { SessionService } from "src/app/services/session.service";

export async function isAuthenticated(): Promise<boolean> {
  try {
    const authenticatedUser = await Auth.currentAuthenticatedUser();
    return !!authenticatedUser;
  } catch (e) {
    return false;
  }
}

export async function getCognitoUser(): Promise<any> {
  return await Auth.currentAuthenticatedUser();
}

export async function logout(
  member: Member | undefined | null,
  sessionService: SessionService
): Promise<void> {
  AppModule.Injector.get(LocalStorageService).clear();

  if (member) {
    await sessionService.deleteByMemberId(member.id);
  }

  sessionService.delete();

  await Auth.signOut({
    global: true
  });
}

export async function changePassword(
  oldPassword: string,
  newPassword: string
): Promise<void> {
  const currentUser = await Auth.currentAuthenticatedUser();
  await Auth.changePassword(currentUser, oldPassword, newPassword);
}
